import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IVehicle } from 'src/core/interfaces/vehicle';
import { de } from 'date-fns/locale';

@Injectable({
  providedIn: 'root'
})
export class VehicleService {

  private _baseUrl = `${environment.apiURL}/api`;

  constructor(private http: HttpClient) { }

  getVehicles(include = true){
    return this.http.get<any>(`${this._baseUrl}/vehicle`,{
      params:{
        include: include
      }
    });
  }
  getVehicleById(id: number){
    return this.http.get<any>(`${this._baseUrl}/vehicle/${id}`);
  }

  addVehicle(vehicle: IVehicle){
    const form = new FormData();
    form.append("color",vehicle.color);
    form.append("isActive",vehicle.isActive.toString());

    form.append("defaultDriverId",vehicle.defaultDriverId!=null?vehicle.defaultDriverId:null);
    form.append("transporterId", vehicle.transporterId!=null? vehicle.transporterId.toString():null);

    form.append("model",vehicle.model);
    form.append("manufacturer",vehicle.manufacturer);
    form.append("name",vehicle.name);
    form.append("platNumber",vehicle.platNumber);
    form.append("license",vehicle.license);
    form.append("licenseNumber",vehicle.licenseNumber);
    form.append("imei",vehicle.imei);
    form.append("isInternal",vehicle.isInternal!=null?vehicle.isInternal.toString():null);
    // for (const index in vehicle.drivers) 
    // {
    //   form.append(`Drivers[${index}]`,vehicle.drivers[index].toString());
    // }
    return this.http.post<any>(`${this._baseUrl}/vehicle/Add`,form);
  }

  updateVehicle(id: number, vehicle: IVehicle){
    // // debugger;
    const form = new FormData();
    form.append("color",vehicle.color);
    form.append("defaultDriverId",vehicle.defaultDriverId!=null?vehicle.defaultDriverId:null);
    form.append("transporterId", vehicle.transporterId!=null? vehicle.transporterId.toString():null);
    form.append("model",vehicle.model);
    form.append("manufacturer",vehicle.manufacturer);
    form.append("name",vehicle.name);
    form.append("platNumber",vehicle.platNumber);
    form.append("license",vehicle.license);
    form.append("licenseNumber",vehicle.licenseNumber);
    form.append("imei",vehicle.imei);
    form.append("isInternal",vehicle.isInternal!=null?vehicle.isInternal.toString():null);
    form.append("isActive",vehicle.isActive.toString());

    // for (const index in vehicle.drivers) 
    // {
    //   form.append(`Drivers[${index}]`,vehicle.drivers[index].toString());
    // }
    return this.http.patch<any>(`${this._baseUrl}/vehicle/${id}`, form);

  }




  deleteVehicles(ids: number[]){
    return this.http.delete<any>(`${this._baseUrl}/vehicle/delete/range`,{body: ids});
  }

  deleteVehicle(id: number){
    return this.http.delete<any>(`${this._baseUrl}/vehicle/${id}`)
  }
  getPaginatedVehicles(pageIndex = 0, pageSize = 10, pagination = false, criteria = null, isActive = -1){
    return this.http.get<any>(`${this._baseUrl}/vehicle/paginated/${isActive}?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}${criteria != null ? "&criteria="+criteria : ""}`)
  }

  getTransporterVehicles(id: number){
    return this.http.get<any>(`${this._baseUrl}/vehicle/transportervehicles/${id}`);
  }
}
